import React from "react"
import PropTypes from "prop-types"

/**
 * Checkbox controlled via label click — avoids reactstrap/Formik form conflicts
 * (same pattern as super-admin plan module selection).
 */
const NativeCheckbox = ({
  id,
  checked,
  onActivate,
  className = "",
  inputStyle,
  children,
}) => (
  <label
    htmlFor={id}
    className={className}
    style={{ cursor: "pointer", userSelect: "none", marginBottom: 0 }}
    onClick={e => {
      e.preventDefault()
      e.stopPropagation()
      onActivate()
    }}
  >
    <input
      id={id}
      type="checkbox"
      readOnly
      checked={!!checked}
      tabIndex={-1}
      style={{
        width: 16,
        height: 16,
        flexShrink: 0,
        accentColor: "var(--bs-primary, #556ee6)",
        pointerEvents: "none",
        ...inputStyle,
      }}
    />
    {children}
  </label>
)

NativeCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onActivate: PropTypes.func.isRequired,
  className: PropTypes.string,
  inputStyle: PropTypes.object,
  children: PropTypes.node,
}

export default NativeCheckbox
